/**
 * API 配置
 *
 * OAuth2 模式：使用 Bearer token 进行认证
 * 通过 @zero/auth 的 React 绑定注册认证状态
 */

import { resolveApiBase } from "@zero/utils/api-base";

type AuthContextReader = {
  getAuthHeaders: () => Record<string, string>;
  getUserId: () => string;
};

let authContextReader: AuthContextReader | null = null;

export const API_CONFIG = {
  /**
   * API 基础 URL
   */
  BASE_URL: resolveApiBase(import.meta.env.VITE_API_BASE_URL, "http://localhost:8081"),

  /**
   * 注册认证上下文读取器
   */
  setAuthContext(reader: AuthContextReader): void {
    authContextReader = reader;
  },

  /**
   * 清除认证上下文读取器
   */
  clearAuthContext(): void {
    authContextReader = null;
  },

  /**
   * 获取认证头
   * 从 @zero/auth React 上下文读取当前有效的 access token
   */
  getAuthHeaders(): Record<string, string> {
    return authContextReader?.getAuthHeaders() ?? {};
  },

  /**
   * 获取当前用户 ID
   * 从 @zero/auth React 上下文读取当前用户
   */
  getUserId(): string {
    const userId = authContextReader?.getUserId();
    if (userId) {
      return userId;
    }
    throw new Error("User not authenticated");
  },

  /**
   * 请求超时时间（毫秒）
   */
  TIMEOUT: 30000,
};
